import React from 'react';
import { Grid, Typography } from '@mui/material';

import type { SpotIdealConditions } from 'types/spot';

import { SurfIcon, SwellIcon, TideIcon, WindIcon } from '../Icons';

import Styles from './IdealConditions.module.scss';

type ConditionType = 'size' | 'swellDirection' | 'tide' | 'windDirection';

const idealConditionTypes: {
  image: React.ReactNode;
  title: string;
  type: ConditionType;
}[] = [
  {
    title: 'Swell Direction',
    type: 'swellDirection',
    image: <SwellIcon className={Styles.icon} />,
  },
  {
    title: 'Wind',
    type: 'windDirection',
    image: <WindIcon className={Styles.icon} />,
  },
  {
    title: 'Surf Height',
    type: 'size',
    image: <SurfIcon className={Styles.icon} />,
  },
  {
    title: 'Tide',
    type: 'tide',
    image: <TideIcon className={Styles.icon} />,
  },
];

export interface IdealConditionsProps {
  conditions: SpotIdealConditions;
}

export const IdealConditions = ({ conditions }: IdealConditionsProps) => (
  <section data-testid="ideal-conditions">
    <Typography component="h3" variant="title2" mt={6}>
      Ideal Surf Conditions
    </Typography>
    <Grid
      container
      alignItems="center"
      pb={{ mobile: 4, tabletLg: 8 }}
      pl={{ mobile: 0, tabletLg: 8 }}
      pr={{ mobile: 0, tabletLg: 8 }}
      pt={{ mobile: 4, tabletLg: 8 }}
      spacing={{ mobile: 6, tabletLg: 8 }}
    >
      {idealConditionTypes.map((condition) => {
        if (!conditions?.[condition?.type]?.description) return null;

        return (
          <Grid
            key={condition.type}
            item
            mobile={12}
            tablet={6}
            data-testid="ideal-conditions-item"
          >
            <div className={Styles.condition}>
              {condition.image}
              <div className="asdaf">
                <Typography
                  variant="subtitle1"
                  component="h4"
                  color="text.primary"
                  className={Styles.conditionTitle}
                >
                  {condition.title}
                </Typography>
                <Typography variant="body" className={Styles.conditionDescription}>
                  {conditions[condition.type]
                    ? conditions?.[condition?.type]?.description
                    : 'Not available for this spot'}
                </Typography>
              </div>
            </div>
          </Grid>
        );
      })}
    </Grid>
  </section>
);

export default IdealConditions;
